import { Outlet } from 'react-router-dom';

const Housing = () => (
  <>
    <Outlet />
  </>
);

export default Housing;
